/**
 * Custom Apps (My Apps) Service
 *
 * API calls for user-defined external app links.
 */

import { apiClient, ApiResponse } from './api';
import type {
  UserCustomApp,
  CreateUserCustomAppDto,
  UpdateUserCustomAppDto,
} from '../types';

const BASE = '/my-custom-apps';

export const customAppsService = {
  getMyCustomApps: async (): Promise<UserCustomApp[]> => {
    const response = await apiClient.get<ApiResponse<UserCustomApp[]>>(BASE);
    return response.data.data;
  },

  create: async (dto: CreateUserCustomAppDto): Promise<UserCustomApp> => {
    const response = await apiClient.post<ApiResponse<UserCustomApp>>(BASE, dto);
    return response.data.data;
  },

  update: async (id: number, dto: UpdateUserCustomAppDto): Promise<UserCustomApp> => {
    const response = await apiClient.patch<ApiResponse<UserCustomApp>>(`${BASE}/${id}`, dto);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },

  toggleFavorite: async (id: number): Promise<{ id: number; isFavorite: boolean }> => {
    const response = await apiClient.patch<ApiResponse<{ id: number; isFavorite: boolean }>>(
      `${BASE}/${id}/favorite`,
    );
    return response.data.data;
  },
};
